import React, { Component } from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import toggle from "../../static/images/toggle.png";
// import bld_logo from "../../static/bld_logo.svg";
// import bld_logo from "../../static/bld_logo_colored.svg";
// import bld_logo from "../../static/bld_logo_white.svg";
import bld_logo from "../../static/bld_logo_square_whitecontent_blackbg.svg";
import '../styles/style.scss';


class HeaderBar extends Component {
  render() {
    return(
      <header>
        <Navbar className="header-nav mobile-scroll" fixed="top" expand="lg">
          <div className="header-content">
            <div className="header-brand">
              <Navbar.Brand href="/">
                <img 
                  className="brand-logo"
                  src={bld_logo}
                  alt="bld.ai"
                />
              </Navbar.Brand>
              <Navbar.Toggle
                aria-controls="basic-navbar-nav"
                ref={button => this.navToggle = button}
              >
                <img src={toggle} alt="Toggle" />
              </Navbar.Toggle>
            </div>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="mr-auto align-items-center">
                <Nav.Link className="navigation-link" href="/">Home</Nav.Link>
                <Nav.Link className="navigation-link" href="/process/">Process</Nav.Link>
                <Nav.Link className="navigation-link" href="/tools/">Tools</Nav.Link>
                <Nav.Link className="navigation-link" href="/solutions/">Solutions</Nav.Link>
                <Nav.Link className="navigation-link" target="_blank" href="//docs.google.com/document/d/e/2PACX-1vSav5uXsr5lqLL9T9HyfiMWhwvDDrMH6o36_52wfj2CwIGi3VEanB157hBsGN2vrMxbreCJiRGlU4su/pub">Vision</Nav.Link>
                <Button className="navigation-button" target="_blank" href="//beta.bld.ai/launch">Launch</Button>
                <Button className="navigation-button" target="_blank" href="//beta.bld.ai/join">Join</Button>

              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
      </header>
    );
  }
}

HeaderBar.propTypes = {
  brand: PropTypes.string.isRequired,
};

export default (HeaderBar);